

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MainButton from '../common/MainButton.vue';
declare const ClipboardItem: any;

@Component({ components: { MainButton } })
export default class AffliateCopy extends Vue {
  @Prop({ required: true })
  affiliateCode!: string;

  @Prop({ required: true })
  isLoading!: boolean;

  code = '';
  buttonlabel = 'Copy';

  created() {
    this.updateCode();
  }

  @Watch('affiliateCode')
  affiliateCodeChange() {
    this.updateCode();
  }

  updateCode() {
    if (this.affiliateCode) {
      this.code =
        (window && window.location.origin) +
        '/a/' +
        this.affiliateCode.toUpperCase();
    }
  }

  copyToClipboard() {
    this.updateButtonCopy();

    const blob = new Blob([this.code], { type: 'text/plain' });
    const clipboardItem = { ['text/plain']: blob } as any;
    const data = [new ClipboardItem(clipboardItem)];

    try {
      const windowNavigator: any = navigator;
      windowNavigator.clipboard.write(data);
    } catch (error) {
      console.error('Unable to copy:', error);
    }

    this.$sendMpEvent({
      event: this.$mp_value.JoinAffiliateCopy,
    });
  }

  updateButtonCopy() {
    this.buttonlabel = 'Copied!';

    setTimeout(() => {
      this.buttonlabel = 'Copy';
    }, 2000);
  }
}
